import { Component, Input } from '@angular/core';

/**
 * Intestazione standard di pagina (piano ui-fixes, F0) — titolo a sinistra, azioni della
 * pagina (es. "Nuovo ...") a destra via `<ng-content>`. Le pagine di configurazione non ne
 * avevano una, rendendo impossibile capire a cosa si riferisse la griglia sottostante.
 */
@Component({
  selector: 'emed-page-header',
  standalone: false,
  templateUrl: './emed-page-header.component.html'
})
export class EmedPageHeaderComponent {
  @Input() title = '';
  @Input() subtitle?: string;
}
